import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { KPI, toYMDLocal } from './shared';
import { SUCURSALES, COLORES, SUCURSAL_NOMBRES } from '../constants';

export function Dashboard({ empleados, cambios, loading }) {
  if (loading) return <div style={{ padding: '40px', textAlign: 'center' }}>Cargando...</div>;

  const porSucursal = {};
  SUCURSALES.forEach(s => porSucursal[s] = 0);
  empleados.forEach(e => {
    if (porSucursal[e.sucursal] !== undefined) porSucursal[e.sucursal]++;
  });

  const dataSucursales = SUCURSALES.map(s => ({ name: SUCURSAL_NOMBRES[s] || s, valor: porSucursal[s], fill: COLORES[s] }));

  const hoyStr = toYMDLocal(new Date());
  const haceSieteDias = new Date();
  haceSieteDias.setDate(haceSieteDias.getDate() - 6);
  const haceSieteDiasStr = toYMDLocal(haceSieteDias);

  const rawFI = (e) => String(e.fecha_ingreso || '').slice(0, 10);
  const rawFB = (e) => String(e.fecha_baja || '').slice(0, 10);

  const altasHoy = empleados.filter(e => rawFI(e) === hoyStr).length;
  const altasSemana = empleados.filter(e => rawFI(e) >= haceSieteDiasStr && rawFI(e) <= hoyStr).length;
  const bajasHoy = empleados.filter(e => rawFB(e) === hoyStr).length;
  const bajasSemana = empleados.filter(e => rawFB(e) >= haceSieteDiasStr && rawFB(e) <= hoyStr).length;

  return (
    <div>
      <div className="page-header">
        <div className="page-title"><i className="ti ti-layout-dashboard"></i> Dashboard</div>
        <div className="page-subtitle">Bienvenido al Sistema Integral de Recursos Humanos</div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '16px', marginBottom: '24px' }}>
        {/* Empleados Activos - Green */}
        <div style={{
          background: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
          borderRadius: '12px',
          padding: '20px',
          color: 'white',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 4px 12px rgba(16, 185, 129, 0.25)',
          transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
          cursor: 'default',
          minHeight: '110px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = '0 12px 28px rgba(16, 185, 129, 0.35)';
          e.currentTarget.style.transform = 'translateY(-4px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.25)';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
        >
          <div style={{ position: 'absolute', top: '-10px', right: '-10px', fontSize: '60px', opacity: 0.1 }}>
            <i className="ti ti-check"></i>
          </div>
          <div style={{ position: 'relative', zIndex: 1 }}>
            <div style={{ fontSize: '12px', fontWeight: 500, opacity: 0.9, marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <i className="ti ti-check" style={{ fontSize: '16px' }}></i>
              Empleados Activos
            </div>
            <div style={{ fontSize: '32px', fontWeight: 800 }}>{empleados.filter(e => e.estatus === 'Activo').length}</div>
          </div>
        </div>

        {/* Cambios Pendientes - Red */}
        <div style={{
          background: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
          borderRadius: '12px',
          padding: '20px',
          color: 'white',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 4px 12px rgba(239, 68, 68, 0.25)',
          transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
          cursor: 'default',
          minHeight: '110px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = '0 12px 28px rgba(239, 68, 68, 0.35)';
          e.currentTarget.style.transform = 'translateY(-4px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(239, 68, 68, 0.25)';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
        >
          <div style={{ position: 'absolute', top: '-10px', right: '-10px', fontSize: '60px', opacity: 0.1 }}>
            <i className="ti ti-alert-triangle"></i>
          </div>
          <div style={{ position: 'relative', zIndex: 1 }}>
            <div style={{ fontSize: '12px', fontWeight: 500, opacity: 0.9, marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <i className="ti ti-alert-triangle" style={{ fontSize: '16px' }}></i>
              Cambios Pendientes
            </div>
            <div style={{ fontSize: '32px', fontWeight: 800 }}>{cambios.filter(c => c.estatus === 'Pendiente_Intellisis').length}</div>
          </div>
        </div>

        {/* Altas/Bajas Hoy - Blue */}
        <div style={{
          background: 'linear-gradient(135deg, #0086ab 0%, #3cafd6 100%)',
          borderRadius: '12px',
          padding: '20px',
          color: 'white',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 4px 12px rgba(0, 134, 171, 0.25)',
          transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
          cursor: 'default',
          minHeight: '110px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = '0 12px 28px rgba(0, 134, 171, 0.35)';
          e.currentTarget.style.transform = 'translateY(-4px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 134, 171, 0.25)';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
        >
          <div style={{ position: 'absolute', top: '-10px', right: '-10px', fontSize: '60px', opacity: 0.1 }}>
            <i className="ti ti-trending-up"></i>
          </div>
          <div style={{ position: 'relative', zIndex: 1 }}>
            <div style={{ fontSize: '12px', fontWeight: 500, opacity: 0.9, marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <i className="ti ti-trending-up" style={{ fontSize: '16px' }}></i>
              Altas / Bajas Hoy
            </div>
            <div style={{ fontSize: '32px', fontWeight: 800 }}>{altasHoy} / {bajasHoy}</div>
          </div>
        </div>

        {/* Altas/Bajas Semana - Cyan */}
        <div style={{
          background: 'linear-gradient(135deg, #0891b2 0%, #06b6d4 100%)',
          borderRadius: '12px',
          padding: '20px',
          color: 'white',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 4px 12px rgba(8, 145, 178, 0.25)',
          transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
          cursor: 'default',
          minHeight: '110px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = '0 12px 28px rgba(8, 145, 178, 0.35)';
          e.currentTarget.style.transform = 'translateY(-4px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(8, 145, 178, 0.25)';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
        >
          <div style={{ position: 'absolute', top: '-10px', right: '-10px', fontSize: '60px', opacity: 0.1 }}>
            <i className="ti ti-calendar"></i>
          </div>
          <div style={{ position: 'relative', zIndex: 1 }}>
            <div style={{ fontSize: '12px', fontWeight: 500, opacity: 0.9, marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
              <i className="ti ti-calendar" style={{ fontSize: '16px' }}></i>
              Altas / Bajas Semana
            </div>
            <div style={{ fontSize: '32px', fontWeight: 800 }}>{altasSemana} / {bajasSemana}</div>
          </div>
        </div>
      </div>

      <div style={{ marginBottom: '24px' }}>
        <div className="card" style={{ display: 'inline-block', width: '50%', minWidth: '320px' }}>
          <div className="card-title">
            <i className="ti ti-chart-bar"></i>
            Empleados por Sucursal
          </div>
          <ResponsiveContainer width="100%" height={125}>
            <BarChart data={dataSucursales}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e8ecf0" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="valor" fill="#0086ab" radius={[8, 8, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
